import { Cart } from '@commercetools/platform-sdk';
import { dollars } from '@nuts/auto-delivery-sdk/dist/utils/money';

import { fromAxiosNutsJson, NutsJson, webstore } from '@/api';
import { NutritionFacts } from '@/api/productNutritionFacts';
import { VolumetricSelection } from '@/lib/customizers/common';
import { sortSelectionsByProductKey } from '@/lib/customizers/mixes';

export interface MixDetails {
  quantity: number;
  mixName?: string;
  selections: VolumetricSelection[];
  weight: number;
}

export async function addMixToCart(mixDetails: MixDetails) {
  const formData = new FormData();
  formData.append('quantity', `${mixDetails.quantity}`);
  if (mixDetails.mixName) formData.append('mix-name', mixDetails.mixName);

  const contents = sortSelectionsByProductKey(mixDetails.selections)
    .map((item: VolumetricSelection) => `${item.parts}x0${item.productKey}`)
    .join(',');
  formData.append('mix-contents', contents);
  formData.append('size', `${mixDetails.weight}`);

  const { cart } = await fromAxiosNutsJson(
    webstore.post<NutsJson<{ cart: Cart }>>('/custom-mixes/create', formData),
    {},
  );

  return cart;
}

export async function addCustomMixToCart(
  variantSku: string,
  variantContents: Record<string, string>,
  options: { onRedirect?: () => void } = {},
) {
  const formData = new FormData();
  formData.append('quantity', '1');
  const contents = Object.entries(variantContents)
    .map(([sku, qty]) => `${qty}x${sku}`)
    .join(',');
  formData.append('mix-contents', contents);
  formData.append('size', `${Number(variantSku.split('-')[1])}`);

  let result;
  try {
    const { cart } = await fromAxiosNutsJson(
      webstore.post<NutsJson<{ cart: Cart }>>('/custom-mixes/create', formData),
      options,
    );
    result = cart;
  } catch (error) {
    console.error(error);
  }
  return result;
}

export async function getNutritionFacts(mixDetails: MixDetails) {
  const formData = new FormData();
  formData.append('weight', `${mixDetails.weight}`);

  mixDetails.selections.forEach((item: VolumetricSelection) => {
    formData.append(`data[${item.productKey}][density]`, `${item.density}`);
    formData.append(`data[${item.productKey}][parts]`, `${item.parts}`);
    formData.append(`data[${item.productKey}][price]`, `${dollars(item.volumePrice)}`);
    formData.append(`data[${item.productKey}][sku]`, `${item.productKey}`);
  });

  const data = await fromAxiosNutsJson<NutritionFacts>(
    webstore.post<NutsJson<NutritionFacts>>('/custom-mixes/item-nutrition', formData),
    {},
  );

  return data;
}
